export const SET_ORDERS = 'SET_ORDERS';
export const SET_ALL_ORDERS = 'SET_ALL_ORDERS';
export const SET_ORDERS_LOADING = 'SET_ORDERS_LOADING';
